module.exports = __webpack_public_path__ + "static/media/135U12_Bedroom.ca4e74ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U12_Bedroom.jpg
// module id = 548
// module chunks = 0